import React, { useEffect } from 'react';

const LoadingScreen = ({ isLoading }) => {
    useEffect(() => {
        if (isLoading) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isLoading]);

    return (
        <div className={`preloader ${!isLoading ? 'hidden' : ''}`}>
            <div className="loader-molecule">
                <div className="loader-atom"></div>
                <div className="loader-atom"></div>
                <div className="loader-atom"></div>
                <div className="loader-atom"></div>
            </div>
        </div>
    );
};

export default LoadingScreen;